module.exports = __webpack_public_path__ + "img/heart-waterblue.391f7293.svg";